import Quill from 'quill'
import React, { useEffect, useState } from 'react';
import { DeleteOutlined } from '@ant-design/icons'
import 'quill/dist/quill.snow.css';
import './style.css'
import { Button, Radio, Space } from 'antd';

interface TextEditorProps {
    callback: (type: 'title1' | 'title2' | 'title3' | 'text', value: string, remove: boolean) => void,
    uniqueId: string
    value: string | null
    type: 'title1' | 'title2' | 'title3' | 'text'
    avoidDeleteBloc?: boolean
}

function changeTextType(type: string, quillEditor: any) {
    switch (type) {
        case 'title1':
            quillEditor.setContents(quillEditor.clipboard.convert({ html: '<strong style="color: rgb(40, 158, 250); font-size: 25px;">Titre 1</strong>' }), 'silent')
            break;
        case 'title2':
            quillEditor.setContents(quillEditor.clipboard.convert({ html: '<strong style="color: rgb(40, 158, 250); font-size: 25px;">Titre 2 : </strong><span style="color: rgb(47, 48, 48); font-size: 25px;">Titre 2</span>' }), 'silent')
            break;
        case 'title3':
            quillEditor.setContents(quillEditor.clipboard.convert({ html: '<strong style="font-size: 18px;">Titre 3 : Titre 3</strong>' }), 'silent')
            break;
        default:
            quillEditor.setContents(quillEditor.clipboard.convert({ html: "<strong>Oui</strong> j'adore pas" }), 'silent')
    }
}


export default function TextEditor(props: TextEditorProps) {
    const [editor, setEditor] = useState<any>()
    const [textPreset, setTextPreset] = useState<'title1' | 'title2' | 'title3' | 'text'>(props.type)
    const [needSaving, setNeedSaving] = useState<boolean>(false)

    useEffect(() => {
        //container
        const container = document.getElementById('text-editor' + props.uniqueId);
        if (!editor && container) {
            //set custom font Open Sans
            var Font: any = Quill.import('formats/font');
            Font.whitelist = ['Open Sans'];
            Quill.register(Font, true);

            //set custom font sizes
            var Size: any = Quill.import('attributors/style/size');
            Size.whitelist = ['13px', '14px', '15px', '16px', '18px', '20px', '22px', '25px', '30px', '35px', '40px', '45px', '50px', '55px', '60px'];
            Quill.register(Size, true);

            //create quill text editor
            const options = {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline'],
                            [{ 'size': ['13px', '14px', '15px', '16px', '18px', '20px', '22px', '25px', '30px', '35px', '40px', '45px', '50px', '55px', '60px'] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            ["customButton"]
                        ],
                        handlers: {
                            customButton: () => {
                                var editor: any = document.querySelector('#text-editor' + props.uniqueId)
                                var selection = editor?.__quill.getSelection(true);
                                editor?.__quill.insertText(selection.index, '//zoneName//');
                            }
                        }
                    }
                },
                theme: 'snow'
            }
            var tempEditor = new Quill(container, options);
            tempEditor.on('text-change', function () {
                setNeedSaving(true)
            })
            console.log(props.value)
            tempEditor.setContents(tempEditor.clipboard.convert({html: props.value || ""}), 'silent');
            setEditor(tempEditor)
        }
    })

    function save() {
        setNeedSaving(false)
        props.callback(textPreset, editor.container.firstChild.innerHTML, false)
    }

    return (
        <div>
            <Radio.Group
                value={textPreset}
                onChange={(e) => {
                    changeTextType(e.target.value, editor)
                    setTextPreset(e.target.value)
                    const str = document.getElementById("text-editor" + props.uniqueId)?.firstElementChild?.innerHTML || ''
                    props.callback(e.target.value, str || '', false)
                }}
                optionType="button"
                buttonStyle="solid"
            >
                {[['title1', 'Titre 1'], ['title2', 'Titre 2'], ['title3', 'Titre 3'], ['text', 'Texte']].map((d, index) => (
                    <Radio key={index} value={d[0]}>
                        {d[1]}
                    </Radio>
                ))}
            </Radio.Group>
            <br />
            <br />
            <div id={'text-editor' + props.uniqueId} />
            <Space style={{ marginTop: 30 }}>
                {!props.avoidDeleteBloc && (
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            const str = document.getElementById("text-editor" + props.uniqueId)?.firstElementChild?.innerHTML || ''
                            props.callback(textPreset, str || '', true)
                        }}
                    >
                        Supprimer le bloc
                    </Button>
                )}
                <Button disabled={!needSaving} onClick={save}>Enregistrer</Button>
                {needSaving && <span style={{ color: 'red' }}>Modifications non enregistrées</span>}
            </Space>
        </div>
    )
}
